import React from 'react'
import {Accordion, Grid, AccordionSummary, AccordionDetails} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import {customStyles, overrideStyle} from './NoticiaStyle';
import TextoEstatico from '../../commons/textoEstatico/TextoEstatico';
import {ThemeProvider} from '@material-ui/core';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

export default function Noticia(props) {

    const [expanded, setExpanded] = React.useState('');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);        
    };

    const crearEntrada = texto =>{
       return texto.length <= 100 ? texto: texto.substring(0, 100) + '...';
    };

    const crearFechaNoticia = fechaNoticia => {
        const fecha = fechaNoticia.substr(0, 10).split('-');
        return fecha[2] + '/' + fecha[1] + '/' + fecha[0];
    }

    return (
        <Grid>
            <h2 className={customStyles().textoTitular}>{props.titular}</h2>
            <p className={customStyles().fecha}>{props.fecha}</p>
            <p className={customStyles().textoEntrada}>{crearEntrada(props.texto)}</p>
            <ThemeProvider theme = {overrideStyle}>
                <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary className = {customStyles().borderNoticia} aria-controls="panel1d-content" id="panel1d-header">
                {expanded ? (<KeyboardArrowDownIcon className={customStyles().claseIcon}/>) : 
                    (<KeyboardArrowRightIcon className={customStyles().claseIcon}/>) }
                    <Typography className={customStyles().typography}>Seguir leyendo</Typography>                                      
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        <TextoEstatico                            
                            {...props.texto}
                            estiloTexto={customStyles().classTextoEstatico}
                            text={props.texto} />                        
                    </Typography>
                </AccordionDetails>
                </Accordion> 
            </ThemeProvider>
        </Grid>
    );
}